import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../../app.state";
import {
  IRequestBusquedaAvanzada,
  ParamsBusqueda,
} from "../../interfaces/busqueda";
import { OrderByPipe } from "../../pipes/order-by.pipe";
import { buscarEntrada } from "../../states/busqueda/actions";
import { selectCatBusquedaAvanzada } from "../../states/busqueda/selector";

@Component({
  selector: "app-search-custom-params",
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    CommonModule,
    MatButtonModule,
    OrderByPipe,
  ],
  providers: [
      { provide: MAT_DATE_LOCALE, useValue: "es-MX" },
      provideNativeDateAdapter(),
  ],
  templateUrl: "./search-custom-params.component.html",
  styleUrl: "./search-custom-params.component.css",
})
export class SearchCustomParamsComponent {
  public tema_descripcion = [];
  public tipo_descripcion = [];
  public modo_entrada_descripcion = [];
  public prioridad_descripcion = [];
  public remitente_enviado_descripcion = [];
  public conCopia_descripcion = [];
  public delegado_descripcion = [];
  public empresa_descripcion = [];
  public estatus_descripcion = [];
  public remitente_descripcion = [];
  public fechaInicioDesde: string = "";
  public fechaInicioHasta: string = "";
  public fechaFinDesde: string = "";
  public fechaFinHasta: string = "";

  combos$!: Observable<any>;
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<SearchCustomParamsComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit(): void {
    this.combos$ = this.store.select(selectCatBusquedaAvanzada);
  }

  close(): void {
    this.dialogRef.close();
  }

  buscar(idsTemas: string[]) {
    this.dialogRef.close();
    const params: ParamsBusqueda = {
      idsTemas,
      tema_descripcion: this.tema_descripcion,
      tipo_descripcion: this.tipo_descripcion,
      modo_entrada_descripcion: this.modo_entrada_descripcion,
      prioridad_descripcion: this.prioridad_descripcion,
      remitente_enviado_descripcion: this.remitente_enviado_descripcion,
      conCopia_descripcion: this.conCopia_descripcion,
      delegado_descripcion: this.delegado_descripcion,
      empresa_descripcion: this.empresa_descripcion,
      estatus_descripcion: this.estatus_descripcion,
      remitente_descripcion: this.remitente_descripcion,
      fechaInicioDesde: this.fechaInicioDesde
        ? new Date(this.fechaInicioDesde.toString()).toISOString()
        : "",
      fechaInicioHasta: this.fechaInicioHasta
        ? new Date(this.fechaInicioHasta.toString()).toISOString()
        : "",
      fechaFinDesde: this.fechaFinDesde
        ? new Date(this.fechaFinDesde.toString()).toISOString()
        : "",
      fechaFinHasta: this.fechaFinHasta
        ? new Date(this.fechaFinHasta.toString()).toISOString()
        : "",
      texto: this.data.busquedaDescripcion ?? "",
    };
    const paramsBusqueda: ParamsBusqueda = this.filtrarCampos(params);
    const payload: IRequestBusquedaAvanzada = {
      paramsBusqueda,
    };

    this.router.navigate(["/consulta"]);
    this.store.dispatch(
      buscarEntrada({
        busqueda: this.data.busquedaDescripcion ?? "",
        tipoBusqueda: "busquedaAvanzada",
        request: payload,
      })
    );
  }

  filtrarCampos(params: ParamsBusqueda): ParamsBusqueda {
    return Object.fromEntries(
      Object.entries(params).filter(([_, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0;
        } else if (typeof value === "string") {
          return value.trim().length > 0;
        }
        return value != null;
      })
    ) as ParamsBusqueda;
  }

  resetFiltos() {
    this.tema_descripcion = [];
    this.tipo_descripcion = [];
    this.tipo_descripcion = [];
    this.modo_entrada_descripcion = [];
    this.prioridad_descripcion = [];
    this.remitente_enviado_descripcion = [];
    this.conCopia_descripcion = [];
    this.delegado_descripcion = [];
    this.empresa_descripcion = [];
    this.estatus_descripcion = [];
    this.remitente_descripcion = [];
    this.fechaInicioDesde = "";
    this.fechaInicioHasta = "";
    this.fechaFinDesde = "";
    this.fechaFinHasta = "";
  }

  disableOption(selected: any[], optionId: string) {
    return selected.length >= 3 && !selected.includes(optionId);
  }
}
